import React from 'react';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2>About Our Company</h2>
            <p>We are committed to delivering premium quality products with a focus on sustainability and customer satisfaction. Our company uses certified, high-quality materials for superior manufacturing.</p>
            <p>With over two decades of expertise in the industry, we bring forth an entire product range designed for your office, home, cars, and travel needs. Our environmentally sustainable approach ensures that every product meets the highest standards of quality and responsibility.</p>
            <p>We prioritize every aspect of our production to ensure that only the best products reach you, making us your one-stop destination for all hygiene and personal care needs.</p>
          </div>
          <div className="about-image">
            <div className="placeholder-image">
              <span>Premium Products Image</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
